/**
 *
 * @param {Object} data { key: Array }
 * @returns {Array}
 */
export default function getSummarySales(data = {}) {
  const t = {
    DELIVERY: 'Delivery',
    STORE_PICKUP: 'Pickup',
    SUBSCRIPTION: 'Subscription',
    RENTAL: 'Rental',
  };

  const initial = {
    totalPaymentPrice: 0,
    totalCount: 0,
    totalDiscount: 0,
    totalCouponCount: 0,
    totalRefundCount: 0,
    totalRefundAmount: 0,
    totalDeliveryAmount: 0,
    totalPointAmount: 0,
  };
  const typeInitial = Object.values(t).reduce((acc, cur) => {
    acc[`total${cur}DeliveryAmount`] = 0;
    acc[`total${cur}PointAmount`] = 0;
    acc[`total${cur}PaymentPrice`] = 0;
    acc[`total${cur}Count`] = 0;
    acc[`total${cur}Discount`] = 0;
    acc[`total${cur}CouponCount`] = 0;
    acc[`total${cur}RefundCount`] = 0;
    acc[`total${cur}RefundAmount`] = 0;
    return acc;
  }, {});

  // 합산
  const summaryData = Object.entries(data).map(([key, value]) => {
    const newValue = value.reduce(
      (acc, cur) => {
        const {
          type,
          refund,
          regular_payment_info,
          rental_payment_info,
          parcel_service_id,
          rental_id,
        } = cur;

        // Shop Order 합산
        if (!parcel_service_id && !rental_id) {
          acc[`totalDeliveryAmount`] += cur.final_delivery_price;
          acc[`totalPointAmount`] += Math.abs(cur.use_point);
          acc[`total${t[type]}DeliveryAmount`] += cur.final_delivery_price;
          acc[`total${t[type]}PointAmount`] += Math.abs(cur.use_point);
        }
        // Parcel, Rental 합산
        else {
          // 환불이 있을 경우 합산
          if (refund) {
            acc.totalRefundCount += 1;
            acc.totalRefundAmount += refund.refund_amount;
            acc[`total${t[type]}RefundCount`] += 1;
            acc[`total${t[type]}RefundAmount`] += refund.refund_amount;
          }

          let paymentPrice = 0,
            discountPrice = 0;
          if (type === 'DELIVERY' || type === 'STORE_PICKUP') {
            paymentPrice = cur.payment_price;
            discountPrice = Math.abs(cur.discount_price);
          } else if (type === 'SUBSCRIPTION') {
            paymentPrice = regular_payment_info.price;
            discountPrice =
              regular_payment_info.regular_payment_id === 1
                ? Math.abs(cur.discount_price ?? 0)
                : Math.abs(regular_payment_info.discount_price ?? 0);
          } else {
            paymentPrice = rental_payment_info.price;
            discountPrice =
              rental_payment_info.rental_payment_id === 1
                ? Math.abs(cur.discount_price ?? 0)
                : Math.abs(rental_payment_info.discount_price ?? 0);
          }

          acc.totalPaymentPrice += paymentPrice;
          acc.totalCount += 1;
          acc.totalDiscount += discountPrice;
          acc.totalCouponCount += cur.coupon_info ? 1 : 0;

          acc[`total${t[type ?? 'RENTAL']}PaymentPrice`] += paymentPrice;
          acc[`total${t[type ?? 'RENTAL']}Count`] += 1;
          acc[`total${t[type ?? 'RENTAL']}Discount`] += discountPrice;
          acc[`total${t[type ?? 'RENTAL']}CouponCount`] += cur.coupon_info
            ? 1
            : 0;
        }

        return acc;
      },
      { ...initial, ...typeInitial }
    );

    // 총매출, 순매출 계산
    const totalInitial = ['totalAmount', 'totalNetAmount', 'totalDiscount'];
    const arrayKey = Object.values(t);
    const totalSummary = new Array(arrayKey.length + 1)
      .fill(null)
      .reduce((acc, _, idx) => {
        const k = arrayKey[idx] ?? '';

        totalInitial.forEach((item) => {
          const split = Object.values(item);

          const newKey = split.toSpliced(5, 0, k).join('');

          if (item === 'totalAmount') {
            acc[newKey] =
              newValue[`total${k}PaymentPrice`] +
              newValue[`total${k}Discount`] +
              newValue[`total${k}PointAmount`] +
              newValue[`total${k}DeliveryAmount`];
          } else if (item === 'totalNetAmount') {
            acc[newKey] =
              newValue[`total${k}PaymentPrice`] -
              newValue[`total${k}RefundAmount`] +
              newValue[`total${k}DeliveryAmount`];
          } else {
            acc[newKey] =
              newValue[`total${k}Discount`] + newValue[`total${k}PointAmount`];
          }
        });

        return acc;
      }, {});

    return {
      key: key,
      ...newValue,
      ...totalSummary,
    };
  });

  return summaryData ?? [];
}
